"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MapperGroups;
(function (MapperGroups) {
    MapperGroups["plateTheft"] = "plateTheft";
    MapperGroups["theft"] = "theft";
    MapperGroups["identification"] = "identification";
    MapperGroups["historicalQueryVin"] = "historicalQueryVin";
    MapperGroups["plateHistory"] = "plateHistory";
    MapperGroups["plateLocation"] = "plateLocation";
    MapperGroups["historicalQueryPlate"] = "historicalQueryPlate";
    MapperGroups["financing"] = "financing";
    MapperGroups["tax"] = "tax";
    MapperGroups["taxPlatedState"] = "tax-plated-state";
    MapperGroups["infraction"] = "infraction";
    MapperGroups["infractionPlatedState"] = "infraction-plated-state";
})(MapperGroups || (MapperGroups = {}));
exports.default = MapperGroups;
